import React, { Fragment } from "react";
import { Col, Row } from "reactstrap";
import OrdersComponent from "../components/Layout/OrdersComponent/OrdersComponent";
import { PageWrapper } from "../components/PageWrapper/PageWrapper";
import { Safearea } from "../components/UI/Safearea/Safearea";
import { Header } from "../components/Layout/Header/Header";

export const Orders = () => {
  return (
    <Fragment>
      <Header title="Órdenes en proceso" />
      <Safearea>
        <OrdersComponent />
      </Safearea>
    </Fragment>
  );
};
